const header = document.querySelector("#header");
const toggleBtn = document.querySelector("#toggle");

const close_header = document.querySelectorAll(".header__innerBlockNavListLi");

// Nav Fixed

toggleBtn.addEventListener("click", () => {
  header.classList.toggle("is-open");
});

close_header.forEach(function (target) {
    target.addEventListener("click", function () {
        header.classList.remove("is-open");
    });
  });
